// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as SavedCardItem$OrcaPaymentPage from "./SavedCardItem.bs.js";
import * as ClickToPayNotYou$OrcaPaymentPage from "./ClickToPayNotYou.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";
import * as ClickToPayUiComponents$OrcaPaymentPage from "./ClickToPayUiComponents.bs.js";

function ClickToPayAuthenticate(props) {
  var setInstallmentsError = props.setInstallmentsError;
  var installmentsError = props.installmentsError;
  var setShowInstallments = props.setShowInstallments;
  var showInstallments = props.showInstallments;
  var setSelectedInstallmentPlan = props.setSelectedInstallmentPlan;
  var closeComponentIfSavedMethodsAreEmpty = props.closeComponentIfSavedMethodsAreEmpty;
  var getVisaCards = props.getVisaCards;
  var cvcProps = props.cvcProps;
  var paymentTokenVal = props.paymentTokenVal;
  var setPaymentToken = props.setPaymentToken;
  var setIsClickToPayAuthenticateError = props.setIsClickToPayAuthenticateError;
  var isClickToPayAuthenticateError = props.isClickToPayAuthenticateError;
  var savedMethods = props.savedMethods;
  var loggerState = props.loggerState;
  var match = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var setClickToPayConfig = match[1];
  var clickToPayConfig = match[0];
  var setShowPaymentMethodsScreen = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var match$1 = React.useState(function () {
        return {};
      });
  var setRequiredFieldsBody = match$1[1];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsShowClickToPayNotYou = match$2[1];
  var match$3 = React.useState(function () {
        return false;
      });
  var consumerIdentity = clickToPayConfig.consumerIdentity;
  var clickToPayProvider = clickToPayConfig.clickToPayProvider;
  var clickToPayCards = clickToPayConfig.clickToPayCards;
  var email = clickToPayConfig.email;
  var setIsCTPAuthenticateNotYouClicked = match$3[1];
  var ctpCards = Core__Option.getOr(clickToPayCards, []);
  var mastercardAuth = function (cards) {
    if (cards.length !== 0) {
      return ;
    }
    if (!(!isClickToPayAuthenticateError && email !== "")) {
      if (isClickToPayAuthenticateError) {
        return closeComponentIfSavedMethodsAreEmpty();
      } else {
        return ;
      }
    }
    var iframe = document.createElement("iframe");
    iframe.id = "mastercard-account-verification-iframe";
    iframe.width = "100%";
    iframe.height = "410px";
    var element = document.getElementById("mastercard-account-verification");
    try {
      if (element == null) {
        return ;
      }
      if (element.children.length !== 0) {
        return ;
      }
      element.appendChild(iframe);
      var iframeContentWindow = iframe.contentWindow;
      if (iframeContentWindow === undefined) {
        return closeComponentIfSavedMethodsAreEmpty();
      }
      var authenticateConsumerIdentity_identityType = consumerIdentity.identityType;
      var authenticateConsumerIdentity_identityValue = consumerIdentity.identityValue.replaceAll(" ", "");
      var authenticateConsumerIdentity = {
        identityType: authenticateConsumerIdentity_identityType,
        identityValue: authenticateConsumerIdentity_identityValue
      };
      var authenticatePayload_windowRef = Caml_option.valFromOption(iframeContentWindow);
      var authenticatePayload = {
        windowRef: authenticatePayload_windowRef,
        consumerIdentity: authenticateConsumerIdentity
      };
      Core__Promise.$$catch(ClickToPayHelpers$OrcaPaymentPage.authenticate(authenticatePayload, loggerState).then(function (res) {
                if (res.TAG === "Ok") {
                  var cards = Core__Option.getOr(Core__Option.flatMap(Core__JSON.Decode.array(Utils$OrcaPaymentPage.getJsonFromDict(Utils$OrcaPaymentPage.getDictFromJson(res._0), "cards", null)), (function (arr) {
                              return arr.map(ClickToPayHelpers$OrcaPaymentPage.clickToPayCardItemToObjMapper);
                            })), []);
                  setClickToPayConfig(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.clickToPayCards = cards;
                        return newrecord;
                      });
                  element.replaceChildren();
                  if (cards.length === 0) {
                    setIsClickToPayAuthenticateError(function (param) {
                          return true;
                        });
                  }
                  if (cards.length === 0 && savedMethods.length === 0) {
                    setShowPaymentMethodsScreen(function (param) {
                          return true;
                        });
                  }
                  return Promise.resolve();
                }
                var errException = Utils$OrcaPaymentPage.formatException(res._0);
                loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                              message: "Error authenticating consumer identity - " + JSON.stringify(errException),
                              scheme: clickToPayProvider
                            }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                var exceptionMessage = Core__Option.getOr(Core__JSON.Decode.string(Utils$OrcaPaymentPage.getJsonFromDict(Utils$OrcaPaymentPage.getDictFromJson(errException), "message", null)), "");
                var isNotYouClicked = exceptionMessage.includes("Not you clicked");
                if (isNotYouClicked) {
                  setIsCTPAuthenticateNotYouClicked(function (param) {
                        return true;
                      });
                  setIsShowClickToPayNotYou(function (param) {
                        return true;
                      });
                } else {
                  setIsClickToPayAuthenticateError(function (param) {
                        return true;
                      });
                }
                element.replaceChildren();
                return Promise.resolve();
              }), (function (err) {
              loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                            message: "Error authenticating consumer identity - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                            scheme: clickToPayProvider
                          }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
              closeComponentIfSavedMethodsAreEmpty();
              return Promise.resolve();
            }));
      return ;
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                    message: "Error - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                    scheme: clickToPayProvider
                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return closeComponentIfSavedMethodsAreEmpty();
    }
  };
  var switchCtpAuthenticate;
  switch (clickToPayProvider) {
    case "VISA" :
        switch (clickToPayConfig.visaComponentState) {
          case "CARDS_LOADING" :
              switchCtpAuthenticate = React.createElement(ClickToPayUiComponents$OrcaPaymentPage.LoadingState.make, {});
              break;
          case "OTP_INPUT" :
              switchCtpAuthenticate = React.createElement(React.Fragment, {}, React.createElement(ClickToPayNotYou$OrcaPaymentPage.ClickToPayNotYouText.make, {
                        setIsShowClickToPayNotYou: setIsShowClickToPayNotYou
                      }), React.createElement("div", {
                        className: "h-4 w-1"
                      }), React.createElement(ClickToPayUiComponents$OrcaPaymentPage.OtpInput.make, {
                        getCards: (function (otp) {
                            return (async function () {
                                        return await getVisaCards(consumerIdentity.identityValue, otp, consumerIdentity.identityType);
                                      })();
                          }),
                        setIsClickToPayRememberMe: props.setIsClickToPayRememberMe
                      }));
              break;
          case "NONE" :
              switchCtpAuthenticate = null;
              break;
          
        }
        break;
    case "MASTERCARD" :
        if (!Core__Option.isNone(clickToPayCards)) {
          mastercardAuth(ctpCards);
        }
        switchCtpAuthenticate = React.createElement("div", {
              id: "mastercard-account-verification"
            });
        break;
    case "NONE" :
        switchCtpAuthenticate = null;
        break;
    
  }
  var ctpCardList = React.createElement(React.Fragment, {}, React.createElement(ClickToPayNotYou$OrcaPaymentPage.ClickToPayNotYouText.make, {
            setIsShowClickToPayNotYou: setIsShowClickToPayNotYou
          }), ctpCards.map(function (obj, i) {
            var customerMethod = PaymentType$OrcaPaymentPage.convertClickToPayCardToCustomerMethod(obj, clickToPayProvider);
            return JsxPPXReactSupportU.createElementWithKey("ctp_" + i.toString(), SavedCardItem$OrcaPaymentPage.make, {
                        setPaymentToken: setPaymentToken,
                        isActive: paymentTokenVal === customerMethod.paymentToken,
                        paymentItem: customerMethod,
                        brandIcon: CardUtils$OrcaPaymentPage.getPaymentMethodBrand(customerMethod),
                        index: i,
                        savedCardlength: ctpCards.length,
                        cvcProps: cvcProps,
                        setRequiredFieldsBody: setRequiredFieldsBody,
                        setSelectedInstallmentPlan: setSelectedInstallmentPlan,
                        showInstallments: showInstallments,
                        setShowInstallments: setShowInstallments,
                        installmentsError: installmentsError,
                        setInstallmentsError: setInstallmentsError,
                        eligibilitySurchargeDetails: undefined
                      });
          }));
  return React.createElement(React.Fragment, {}, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: !isClickToPayAuthenticateError && email !== "",
                  children: React.createElement(ClickToPayHelpers$OrcaPaymentPage.SrcMark.make, {
                        "card-brands": clickToPayConfig.availableCardBrands.join(","),
                        height: "32"
                      })
                }), match$2[0] ? React.createElement(ClickToPayNotYou$OrcaPaymentPage.make, {
                    setIsShowClickToPayNotYou: setIsShowClickToPayNotYou,
                    isCTPAuthenticateNotYouClicked: match$3[0],
                    getVisaCards: getVisaCards
                  }) : (
                ctpCards.length === 0 ? switchCtpAuthenticate : ctpCardList
              ));
}

var make = ClickToPayAuthenticate;

export {
  make ,
}
/* react Not a pure module */
